import { Typography } from "@mui/material"

const BeAwareMobile = () => {
  return (
    <>
     <Typography textAlign={"center"} py={4}>Coming soon... </Typography>
    </>
  )
}

export default BeAwareMobile